import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import theme from './theme/theme';
import LoadingScreen from './components/LoadingScreen';
import PageTransition from './components/animated/PageTransition';
import Home from './pages/home';
import WhoWeAre from './pages/whoWeAre';
import Framework from './pages/framework';
import CapabilitiesHub, { CapabilityDetail } from './pages/capabilities';
import Technology from './pages/technology';
import IndustriesHub, { IndustryDetail } from './pages/industries';
import Insights from './pages/insights';
import Leadership from './pages/leadership';
import Contact from './pages/contact';
import ErmIndex from './pages/ermIndex';

const App = () => {
  const [loading, setLoading] = useState(true);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {loading && <LoadingScreen onComplete={() => setLoading(false)} />}
      <Router>
        <PageTransition>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/framework" element={<Framework />} />
            <Route path="/capabilities" element={<CapabilitiesHub />} />
            <Route path="/capabilities/:slug" element={<CapabilityDetail />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/industries" element={<IndustriesHub />} />
            <Route path="/industries/:slug" element={<IndustryDetail />} />
            <Route path="/Industries" element={<Navigate to="/industries" replace />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/erm-efficiency-index" element={<ErmIndex />} />
            <Route path="/erm-index-efficiency" element={<Navigate to="/erm-efficiency-index" replace />} />

            {/* Legacy redirects */}
            <Route path="/about" element={<Navigate to="/who-we-are" replace />} />
            <Route path="/services" element={<Navigate to="/capabilities" replace />} />
            <Route path="/team" element={<Navigate to="/leadership" replace />} />
          </Routes>
        </PageTransition>
      </Router>
    </ThemeProvider>
  );
};

export default App;
